import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/canalnazca.png";
import Imagen2 from "../../../images/modulo13/anden.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad4 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[6];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[7].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[7].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[5].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
          <h2 className="mb-4">Transformamos nuestro territorio</h2>

            <p>
              La <strong>transformación</strong> de nuestro territorio se ha dado a lo largo de
              la historia. En el espacio diverso que conforma el Perú las
              sociedades se asientan y lo transforman de acuerdo con sus
              necesidades. Por ejemplo, los antiguos habitantes de la costa,
              tuvieron que luchar contra un <strong>territorio desértico</strong> construyendo
              diversos canales que les aseguren el riego de las plantas para la
              agricultura.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Asimismo, en los <strong>terrenos muy accidentados</strong> de la sierra, se
              construyeron andenes para poder cultivar los alimentos.
            </p>
          </div>
        </div>
      </div>{" "}
      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el texto titulado:
            Transformamos nuestro territorio. Elabore algunas preguntas sobre la
            información que brinda el texto. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Cómo se adaptan las personas a un territorio? (Posible
                  respuesta: Para poder adaptarnos al territorio, lo
                  transformamos).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué ejemplos nos brinda el texto sobre cómo los peruanos se
                  han adaptado a su territorio? (Posible respuesta: Se mencionan
                  la construcción de canales de riego y la construcción de
                  andenes)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad señalando que, a lo largo de la historia, los
            peruanos y peruanas hemos transformado el entorno natural para poder
            vivir en un territorio tan heterogéneo y difícil como el peruano.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
